import { ClickTrackingInfo } from "@omni/types/components/tracking/tracking-info/click/click.trackingInfo";

import { EnrichedAnalyticsEvent } from "@/utils/analytics/analytics.types";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsBannerImpression,
    getGoogleAnalyticsBannerImpression
} from "./GoogleAnalyticsBannerImpression";

export interface GoogleAnalyticsBannerClick
    extends GoogleAnalyticsBannerImpression {}

const getGoogleAnalyticsBannerClick = (
    data: EnrichedAnalyticsEvent<ClickTrackingInfo>
): GoogleAnalyticsBannerClick => {
    return getGoogleAnalyticsBannerImpression(
        data,
        GoogleAnalyticsEvents.BannerClick
    );
};

export { getGoogleAnalyticsBannerClick };
